import React from 'react';
import { useTranslation } from 'react-i18next';
import SearchIcon from '@wix/da-ds/pkg/Icons/24x24/Search';
import TextInput from '@wix/da-ds/pkg/formControls/dsPresets/TextInput';
import { BiData } from '@wix/da-bi/pkg/events';
const UserInput = ({ value = '', onChange, className, 'aria-autocomplete': ariaAutocomplete, 'aria-activedescendant': ariaActiveDescendant, 'aria-controls': ariaControls })=>{
    const { t } = useTranslation();
    return /*#__PURE__*/ React.createElement(TextInput, {
        id: "deviant-list-user-input",
        value: value,
        onChange: (ev)=>onChange && onChange(ev.target.value, ev),
        className: className,
        placeholder: t('deviantList.input.filter.placeholder'),
        prefix: /*#__PURE__*/ React.createElement(SearchIcon, null),
        "aria-autocomplete": ariaAutocomplete,
        "aria-activedescendant": ariaActiveDescendant,
        "aria-controls": ariaControls,
        biData: BiData({
            evid: 410
        }),
        label: t('deviantList.input.filter.placeholder'),
        isLabelHidden: true
    });
};
UserInput.displayName = 'UserInput';
export default UserInput;

//# sourceMappingURL=UserInput.js.map